import i18n from 'i18n/config';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const HEIGHT = '100vh';

const StyledContentLoader = styled(ContentLoader).attrs(({ theme }) => ({
  backgroundColor: theme.loaders.contentLoaders.backgroundColor,
  foregroundColor: theme.loaders.contentLoaders.foregroundColor,
}))`
  height: calc(${HEIGHT} - 43px);
`;

const HomePageLoader: React.FC = (props) => {
  const isRTL = i18n.dir() === 'rtl';

  return (
    <StyledContentLoader speed={0.8} width="100vw" height={HEIGHT} rtl={isRTL} className="mt-3" {...props}>
      <rect x="5%" y="2%" rx="10" ry="10" width="90%" height="30%" />
      <rect x="47%" y="34%" rx="3" ry="3" width="30" height="3" />

      <circle cx="11.5%" cy="40%" r="4%" />
      <rect x="23%" y="39%" rx="3" ry="3" width="70%" height="2%" />

      <circle cx="11.5%" cy="50%" r="4%" />
      <rect x="23%" y="49.1%" rx="3" ry="3" width="70%" height="2%" />

      <rect x="3%" y="92%" rx="7%" ry="7%" width="38%" height="7%" />
      <rect x="44%" y="92%" rx="7%" ry="7%" width="53%" height="7%" />
    </StyledContentLoader>
  );
};

export default HomePageLoader;
